import { CustomCellEditorProps } from "ag-grid-react";
import { Select } from "antd";
import { useMemo } from "react";
import { toProjectRoleSelectOptions } from "utils/utils";

type Props = CustomCellEditorProps;

function ProjectUserRoleSelectCellEditor(props: Props) {
  const { stopEditing, context, onValueChange } = props;
  const { allProjectRoles } = context;

  const roleOptions = useMemo(
    () => toProjectRoleSelectOptions(allProjectRoles),
    [allProjectRoles]
  );

  return (
    <Select
      data-testid="ProjectUserRoleSelect"
      open
      allowClear
      optionFilterProp="label"
      virtual={false}
      style={{ width: "100%" }}
      showSearch
      onChange={(id) => {
        onValueChange(id);
        setTimeout(() => {
          stopEditing();
        }, 200);
      }}
      loading={!allProjectRoles}
      options={roleOptions}
    />
  );
}

export default ProjectUserRoleSelectCellEditor;
